<template>
  <vx-card>

    <vs-table-mod :data="classRooms"
                  :max-items="tableConfig.maxItemsPerPage"
                  pagination
                  search
    >

      <template slot="header-left">

        <!--<vs-checkbox  v-model="local.filters.isAvailable" @input="onFiltersCheckboxChange">
          {{ $t('class-room.is-available') }}
        </vs-checkbox>-->

        <vs-checkbox v-model="local.filters.isActive" @input="onFiltersCheckboxChange">
          {{ $t('class-room.is-active') }}
        </vs-checkbox>

        <vs-checkbox v-model="local.filters.isEmptyRoom" @input="onFiltersCheckboxChange">
          {{ $t('class-room.is-empty-room') }}
        </vs-checkbox>

      </template>

      <template slot="header">
        <div class="inline-flex">

          <vx-tooltip :text="$t('general.add') + $t('class-room.class-room')">
            <vs-button
              @click="onAddClick"
              class="ml-2" color="primary" icon="icon-plus" icon-pack="feather" radius
              type="filled"></vs-button>
          </vx-tooltip>

          <vx-tooltip :text="$t('general.refresh')">
            <vs-button @click.prevent="onRefreshClick" class="ml-2" color="primary" icon="icon-refresh-cw"
                       icon-pack="feather" radius
                       type="filled"></vs-button>
          </vx-tooltip>


        </div>
      </template>

      <template slot="thead"
                v-for="(thead, indexth) in table.header"
      >
        <vs-th :key="indexth" :sort-key="thead.id">
          {{ $t(thead.title) }}
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr
          :data="{ data: tr, index: indextr }"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td width="40">
            {{ indextr + 1 }}
          </vs-td>

          <vs-td>
            {{ tr.nameLocal }}
          </vs-td>
          <vs-td>

            <div class="flex items-center text-break">
              <vs-avatar :src="tr.teacher ? getAvatarUrl(tr.teacher.picturePath):''" class="flex-shrink-0 mr-2"
                         size="30px"
              />
              {{ tr.teacher ? tr.teacher.firstNameLocal + ' '+ tr.teacher.lastNameLocal:'-'}}
            </div>
          </vs-td>
          <vs-td>
            {{ tr.studentRegisterQty + '/' +tr.capacity }}
          </vs-td>
          <vs-td>
            {{ moment(tr.startDate).format(dateTimeFormat.momentYYYYMMDD) }}
          </vs-td>
          <vs-td>
            <span
              :class="checkNearExpired(indextr)">{{ moment(tr.endDate).format(dateTimeFormat.momentYYYYMMDD) }}</span>
          </vs-td>
          <vs-td>
            <vs-avatar v-if="tr.isActive" color="success" icon-pack="feather" icon="icon-check"/>
            <vs-avatar v-if="!tr.isActive" color="grey" icon-pack="feather" icon="icon-x"/>
          </vs-td>
          <!--<vs-td>
            <vs-avatar v-if="tr.isAvailable" color="success" icon-pack="feather" icon="icon-check"/>
            <vs-avatar v-if="!tr.isAvailable" color="grey" icon-pack="feather" icon="icon-x"/>
          </vs-td>-->
          <vs-td class="whitespace-no-wrap" width="100">

            <feather-icon @click="onEditClick(tr)" icon="EditIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
            <!--<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.prevent="onDeleteClick(tr)" />-->
          </vs-td>

        </vs-tr>
      </template>
    </vs-table-mod>

  </vx-card>
</template>

<script>
  import {state, template, clearFormData, loadData} from '../data';
  import moment from "moment";
  import {tableConfig} from '@/utils/table'
  import {dateTimeFormat} from '@/utils/format'
  import {getAvatarUrl} from "@/utils/upload";
  import {MODE_ADD, MODE_EDIT} from '@/utils/page-mode'

  import ClassRoom from '@/store/modules/class-room/class-room/index';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.ClassRoom) state.registerModule(`ClassRoom`, ClassRoom);

  const {
    mapActions: mapClassRoomActions,
  } = createNamespacedHelpers(`ClassRoom`);

  const {mapFields: mapClassRoomFields} = createHelpers({
    getterType: `ClassRoom/getField`,
    mutationType: `ClassRoom/updateField`,
  });

  export default {
    components: {
      vsTableMod: () => import('@/components/vuesax-mod/components/vsTable/vsTable.vue'),
    },
    data() {
      return {
        store: state.store,
        local: state.local,
        table: template.table,
        moment: moment,
        dateTimeFormat: dateTimeFormat,
        tableConfig: tableConfig,
        getAvatarUrl: getAvatarUrl,
      }
    },
    computed: {
      ...mapClassRoomFields({classRoomProcessing: 'processing'}),
      classRooms() {
        return this.local.classRooms;
      }
    },
    watch: {
      classRoomProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapClassRoomActions({
        getClassRoomsByFilter: 'getClassRoomsByFilter',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onAddClick() {
        clearFormData();
        this.$router.push(
          {
            name: "class-room-add",
            params: {
              id: null,
              mode: MODE_ADD,
            }
          }
        );
      },
      async onRefreshClick() {
        await this.loadData();
      },
      onEditClick(tr) {
        this.$router.push(
          {
            name: "class-room-edit",
            params: {
              id: tr.id,
              mode: MODE_EDIT,
            }
          }
        );
      },
      async onFiltersCheckboxChange(){
        await this.loadData();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      checkNearExpired(index) {
        let today = moment().format(this.dateTimeFormat.momentYYYYMMDD);
        let nextMonth = moment().add(30, 'months').format(this.dateTimeFormat.momentYYYYMMDD);
        let endDate = moment(this.classRooms[index].endDate).format(this.dateTimeFormat.momentYYYYMMDD);

        if (moment(today).isAfter(endDate)) {
          return 'text-danger';
        } else if (moment(nextMonth).isAfter(endDate)) {
          return 'text-warning';
        }

        return null;
      },
      async loadData() {
        let func = {getClassRoomsByFilter: this.getClassRoomsByFilter};
        await loadData(func);
      },
    },
    async mounted() {
      await this.loadData();
    }
  }
</script>

<style scoped>

</style>
